import {ValueObject} from '@s-ui/domain'

export class SearchVehiclesResultsValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Object} params.appliedFilters
   * @param {Array.<{make: String, model: String, bodyType: String, doors: Number,  fuelType: String, hp: Number, url: String, version: String, yearFrom: Number, yearTo: Number}>} params.items
   * @param {Object} params.meta
   */
}
